import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';

const sendOTP = async (email: string, accountNeeded?: boolean) => {
  return axios.post(`${API_URL}/account/otp`, { email, accountNeeded });
};

export const useSendOTP = () => {
  return useMutation({
    mutationFn: (data: { email: string, accountNeeded?: boolean }) => sendOTP(data.email, data.accountNeeded),
  });
}; 